/* A&Y — cadeaux offerts (v8), suite : fiche produit, tiroir panier, page panier et accès direct au panier.
   S'appuie sur window.ayGifts (assets/ay-gifts.js, chargé juste avant). */
(() => {
  'use strict';
  const G = window.ayGifts;
  if (!G) return;
  const { T1, T2, VIP, PROP, money, L, el, isMinus, labelOf, parseCatalog, findSaved, slotsFor, resolve, differs, minusKey, enqueue, getCart, postAttributes, saveAttributes, Picker, loadCatalog } = G;
  const S = G.en ? {
    note: 'Optional: tap the photo to add this item too at 10% off, then choose its colour. It is added with “Add to cart”.',
    msg: 'Choose a colour for the ticked item, or untick it.',
    done: 'Noted: your gift is prepared with your order. You can still change it.'
  } : {
    note: 'Facultatif : touchez la photo pour ajouter aussi ce produit à −10 %, puis choisissez sa couleur. Il s’ajoute avec « Ajouter au panier ».',
    msg: 'Choisissez la couleur du produit coché, ou décochez-le.',
    done: 'C’est noté : votre cadeau est préparé avec votre commande. Vous pouvez encore le changer.'
  };

  /* ---------- Fiche produit ---------- */
  function initProduct() {
    const box = document.querySelector('[data-ay-pdp-gift]');
    if (!box) return;
    const form = box.closest('form');
    const mount = box.querySelector('[data-ay-gift-mount]');
    const title = box.querySelector('[data-ay-gift-title]');
    const text = box.querySelector('[data-ay-gift-text]');
    const prop = box.querySelector('[data-ay-gift-prop]');
    const products = (parseCatalog(box.querySelector('[data-ay-gift-catalog]')) || {}).minus || [];
    let variants = [];
    try { variants = JSON.parse(box.closest('[data-ay-product]')?.querySelector('[data-product-variants-json]')?.textContent || '[]'); } catch (_) {}
    let cart = { total_price: Number(box.dataset.cartTotal) || 0, items: [], attributes: {} };
    let cartLoaded = false;
    let pending = '';
    let chosenLabel = '';
    let shown = '';
    const variantId = () => String(form?.querySelector('[name="id"]')?.value || '');
    const qty = () => Math.max(1, parseInt(form?.querySelector('[name="quantity"]')?.value, 10) || 1);
    const linePrice = () => { const v = variants.find(x => String(x.id) === variantId()); return (v ? Number(v.price) || 0 : Number(box.dataset.price) || 0) * qty(); };
    const inCart = () => (cartLoaded ? cart.items.some(i => String(i.variant_id) === variantId()) : box.dataset.inCart === 'true');
    const projected = () => (inCart() ? G.eligible(cart) : G.eligible(cart) + linePrice());
    const savedMinus = () => { const r = resolve(G.eligible(cart), cart.attributes || {}); return isMinus(r['Cadeau 1']) ? r['Cadeau 1'] : isMinus(r['Cadeau 2']) ? r['Cadeau 2'] : ''; };
    /* Shop Pay achète seulement cet article : la propriété n'est jointe que si l'article seul atteint 50 $. */
    const syncProp = state => {
      if (state === 'open' && chosenLabel && linePrice() >= T1) { prop.name = PROP; prop.value = chosenLabel; }
      else { prop.removeAttribute('name'); prop.value = ''; }
    };
    const onPick = async (value, p, v) => {
      chosenLabel = labelOf(p, v);
      syncProp('open');
      if (inCart() || G.eligible(cart) >= T1) {
        pending = '';
        await enqueue(async () => {
          const fresh = await getCart();
          cart = fresh; cartLoaded = true;
          cart = await postAttributes({ [minusKey(G.eligible(fresh))]: value }, 'pdp');
        });
        return L.added;
      }
      pending = value;
      return L.pending;
    };
    function render(force) {
      const total = projected();
      const state = total >= VIP ? 'vip' : total >= T1 ? 'open' : 'locked';
      box.dataset.state = state;
      ['locked', 'open', 'vip'].forEach(s => box.classList.toggle('ay-gifts--' + s, s === state));
      if (state === 'locked') { title.textContent = L.lockedTitle; text.textContent = L.locked(money(T1 - total)); }
      else if (state === 'vip') { title.textContent = L.vipTitle; text.textContent = L.vip; }
      else {
        title.textContent = L.openTitle;
        text.textContent = (linePrice() >= T1 || inCart() ? L.openPdp : L.openPdpCart) + (total >= T2 ? ' ' + L.second : '');
      }
      const choosing = state === shown && mount.querySelector('.ay-gifts__variants:not([hidden])');
      if ((force && !choosing) || state !== shown) {
        shown = state;
        mount.replaceChildren();
        if (state === 'locked') mount.append(Picker({ products, preview: true }));
        else if (state === 'open') {
          const saved = pending || savedMinus();
          const found = findSaved(products, saved);
          chosenLabel = found ? labelOf(found.p, found.v) : '';
          mount.append(Picker({ products, saved, savedState: pending ? L.pending : L.added, onPick }));
        }
      }
      syncProp(state);
    }
    /* « Ajouter au panier » : le cadeau va dans le panier (attribut), pas en propriété de ligne (réservée à Shop Pay).
       On retire le nom du champ le temps que ay-theme.js lise le formulaire, puis on le remet. */
    form?.addEventListener('submit', () => {
      if (!prop.name) return;
      const name = prop.name;
      prop.removeAttribute('name');
      setTimeout(() => { if (!prop.name && prop.value) prop.name = name; }, 0);
    }, true);
    const later = () => setTimeout(() => render(false), 0);
    form?.addEventListener('change', later);
    form?.addEventListener('input', later);
    form?.addEventListener('click', event => { if (event.target.closest('[data-ay-qty-minus], [data-ay-qty-plus], [data-option-select], label')) later(); });
    document.addEventListener('ay:cart:updated', event => {
      if (!event.detail || typeof event.detail.total_price !== 'number') return;
      cart = event.detail; cartLoaded = true;
      /* Cadeau choisi avant l'ajout : enregistré dès que l'article est au panier (aussi quand l'app Sleek fait l'ajout). */
      if (pending && inCart() && G.eligible(cart) >= T1 && G.eligible(cart) < VIP) {
        const value = pending;
        pending = '';
        enqueue(async () => {
          const fresh = await getCart();
          cart = await postAttributes({ [minusKey(G.eligible(fresh))]: value }, 'pdp');
          render(true);
        }).catch(() => { pending = value; render(true); });
        return;
      }
      render(false);
    });
    document.addEventListener('ay:gifts:saved', event => {
      if (!event.detail?.cart) return;
      cart = event.detail.cart; cartLoaded = true;
      if (event.detail.source !== 'pdp') render(true);
    });
    /* Ajout au panier : le cadeau choisi avant l'ajout est enregistré juste après, sans second clic. */
    document.addEventListener('ay:cart:added', event => {
      if (event.detail?.form !== form) return;
      const value = pending;
      pending = '';
      enqueue(async () => {
        const fresh = await getCart();
        cart = fresh; cartLoaded = true;
        if (value && G.eligible(fresh) >= T1 && G.eligible(fresh) < VIP) {
          cart = await postAttributes({ [minusKey(G.eligible(fresh))]: value }, 'pdp');
        }
        render(true);
      }).catch(() => { render(true); });
    });
    render(true);
    getCart().then(fresh => { cart = fresh; cartLoaded = true; render(true); }).catch(() => {});
  }

  /* ---------- Tiroir panier ---------- */
  const drawer = document.getElementById('AYCartDrawer');
  let drawerBox = null;
  let drawerTimer = 0;
  let drawerRun = 0;
  function ensureDrawerBox() {
    if (!drawer) return null;
    if (drawerBox && drawer.contains(drawerBox)) return drawerBox;
    drawerBox = el('div', 'ay-gifts ay-gifts--drawer');
    drawerBox.setAttribute('data-ay-drawer-gifts', '');
    drawerBox.hidden = true;
    const status = drawer.querySelector('[data-ay-cart-status]');
    if (status) status.insertAdjacentElement('afterend', drawerBox);
    else drawer.querySelector('.ay-cart-drawer__body')?.prepend(drawerBox);
    return drawerBox;
  }
  async function renderDrawer(fromEvent) {
    const box = ensureDrawerBox();
    if (!box) return;
    const run = ++drawerRun;
    await G.idle();
    let cart = fromEvent;
    try { cart = await getCart(); } catch (_) {}
    if (!cart || run !== drawerRun) return;
    const total = G.eligible(cart) || 0;
    const attrs = cart.attributes || {};
    const wanted = resolve(total, attrs);
    if (differs(wanted, attrs)) { try { cart = await saveAttributes(wanted, 'drawer'); } catch (_) {} }
    if (run !== drawerRun) return;
    if (!cart.item_count || total < T1) { box.hidden = true; box.replaceChildren(); return; }
    if (total >= VIP) { box.replaceChildren(el('p', 'ay-gifts__title', L.vipTitle), el('p', 'ay-gifts__text', L.vip)); box.hidden = false; return; }
    const slots = slotsFor(total);
    let catalog;
    try { catalog = await loadCatalog(slots.some(s => s.coll === 'doux')); } catch (_) { box.hidden = true; return; }
    if (run !== drawerRun) return;
    const resolved = resolve(total, cart.attributes || {});
    const allChosen = slots.every(slot => resolved[slot.key]);
    const parts = [el('p', 'ay-gifts__title', L.drawerTitle(slots.length)), el('p', 'ay-gifts__text', allChosen ? S.done : L.drawerText)];
    slots.forEach((slot, i) => {
      parts.push(Picker({
        products: catalog[slot.coll] || [],
        label: slots.length > 1 ? L.slot(i + 1, slot.coll === 'doux' ? 'Tout Doux' : 'MINUS') : '',
        saved: resolved[slot.key],
        savedState: L.added,
        onPick: value => saveAttributes({ [slot.key]: value }, 'drawer').then(() => L.added)
      }));
    });
    if (!allChosen) parts.push(el('p', 'ay-gifts__fine', L.fine));
    box.replaceChildren(...parts);
    box.hidden = false;
  }
  if (drawer) {
    const note = drawer.querySelector('.ay-cart-drawer__note');
    if (note) note.textContent = note.textContent.split('Cadeaux et promos en cours : choisissez-les à l’étape suivante.').join('').split('Gifts and current offers: choose yours on the next step.').join('').trim();
    document.addEventListener('ay:cart:updated', event => {
      clearTimeout(drawerTimer);
      drawerTimer = setTimeout(() => { renderDrawer(event.detail); }, 60);
    });
    document.addEventListener('ay:gifts:saved', event => { if (event.detail?.source !== 'drawer' && drawer.open) { clearTimeout(drawerTimer); drawerTimer = setTimeout(() => renderDrawer(event.detail.cart), 60); } });
  }

  /* ---------- Page panier ---------- */
  function initCartPage() {
    const box = document.querySelector('[data-ay-cart-gifts]');
    if (!box) return;
    const total = Number(box.dataset.total) || 0;
    const catalog = parseCatalog(box.querySelector('[data-ay-gift-catalog]')) || {};
    const mount = box.querySelector('[data-ay-gift-mount]');
    const input = key => document.querySelector(`[data-gift-value="${key}"]`);
    const draw = () => {
      mount.replaceChildren(...slotsFor(total).map((slot, i) => Picker({
        products: catalog[slot.coll] || [],
        label: L.slot(i + 1, slot.coll === 'doux' ? 'Tout Doux' : 'MINUS'),
        saved: input(slot.key)?.value || '',
        savedState: L.added,
        onPick: value => {
          const field = input(slot.key);
          if (field) field.value = value;
          return saveAttributes({ [slot.key]: value }, 'cart').then(() => L.added);
        }
      })));
    };
    draw();
    document.addEventListener('ay:gifts:saved', event => {
      const attrs = event.detail?.cart?.attributes || {};
      ['Cadeau 1', 'Cadeau 2'].forEach(key => { const field = input(key); if (field && typeof attrs[key] === 'string') field.value = attrs[key]; });
      if (event.detail?.source !== 'cart') draw();
    });
  }

  /* ---------- Sleek Bundles « Souvent achetés ensemble » ----------
     L'app plaçait son encart tout en bas de la fiche, produit coché d'office : « Ajouter au panier » et Shop Pay
     faisaient alors descendre la page jusqu'à lui pour exiger une couleur, puis il fallait remonter et recliquer.
     Ici : l'encart est replacé juste sous les boutons d'achat, décoché au départ (c'est une option), avec une phrase claire. */
  function tameSleek() {
    const links = document.querySelector('.ay-pdp__cart-links');
    if (!links) return;
    const slot = el('div', 'ay-pdp__sleek');
    slot.hidden = true;
    slot.append(el('p', 'ay-sleek-note', S.note));
    links.insertAdjacentElement('afterend', slot);
    const touched = new Set();
    slot.addEventListener('click', event => {
      if (!event.isTrusted) return;
      const tile = event.target.closest('.sb-fbt-tile');
      if (tile) touched.add(tile.getAttribute('data-i'));
    }, true);
    let frame = 0;
    const tame = () => {
      frame = 0;
      document.querySelectorAll('.sleekbundles-widget').forEach(widget => {
        if (widget.closest('#AYCartDrawer')) return;
        if (!slot.contains(widget)) slot.append(widget);
        widget.classList.remove('sb-bp');
        widget.querySelectorAll('.sb-fbt-tile.sb-fbt-on:not(.sb-fbt-anchor)').forEach(tile => {
          const key = tile.getAttribute('data-i');
          if (tile.dataset.ayOptIn || touched.has(key)) return;
          tile.dataset.ayOptIn = '1';
          tile.click();
        });
        widget.querySelectorAll('.sb-msg').forEach(msg => {
          const txt = msg.textContent.trim();
          if (txt && txt !== S.msg && /choisir|choose|select/i.test(txt)) msg.textContent = S.msg;
        });
        slot.hidden = false;
      });
    };
    const schedule = () => { if (!frame) frame = setTimeout(tame, 30); };
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
    schedule();
  }

  /* ---------- Accès panier : bandeau en bas de page, onglet sur le bord droit, compteur à côté de Shop Pay ---------- */
  document.addEventListener('ay:cart:updated', event => {
    const cart = event.detail;
    if (!cart || typeof cart.item_count !== 'number') return;
    document.querySelectorAll('[data-ay-band-summary]').forEach(node => { node.textContent = cart.item_count ? `${L.items(cart.item_count)} · ${money(cart.total_price)}` : L.empty; });
    document.querySelectorAll('[data-ay-cart-count-inline]').forEach(node => { node.textContent = cart.item_count ? `(${cart.item_count})` : ''; });
    document.querySelectorAll('[data-ay-cart-band]').forEach(node => { node.hidden = node.dataset.always !== 'true' && !cart.item_count; });
    document.querySelectorAll('[data-ay-cart-tab]').forEach(node => { node.hidden = !cart.item_count; });
  });

  initProduct();
  initCartPage();
  tameSleek();
})();